import axios from 'axios'
import qs from 'qs';
import {message} from 'element-ui';
import store from '../../store/index.js';     //在js文件引入store模块
import {Storage} from '../../utils/storage';

let BaseUrl = '';
// 测试环境下
if (process.env.NODE_ENV === "development") {
  BaseUrl = 'https://sh-pdd.52dsy.com';
} else {
  BaseUrl = 'https://aqsp.junpuba.cn';
}
export {BaseUrl}

// 图片接口
export let imgUplUrl = 'https://img.52dsy.com';

axios.interceptors.request.use((config) => {
  let Token = '';
  if (store.state.token) {                                                  // 前台Token
    Token = store.state.token;
  }
  config.headers.common['Token'] = Token;
  config.headers.common['X-PDD-Pati'] = Storage.get('pddPati');
  config.headers.common['X-PDD-PageCode'] = Storage.get('pageCode');
  if (Storage.get('verifyAuthToken')) {
    config.headers.common['X-PDD-VerifyAuthToken'] = Storage.get('verifyAuthToken');
  }
  return config;
}, (err) => {
  message.error('请求超时!')
  return Promise.resolve(err)
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error);
})

axios.interceptors.response.use(response => {
  // 数据统一校验处理
  return response
}, (error) => {
  return Promise.reject(error.response.data)
})

export async function getUrl(url, method, options, ReqHttps) {
  let $https = '';
  // 上传图片
  if (ReqHttps === 'MatSpace') {
    $https = imgUplUrl;
  } else {
    $https = BaseUrl;
  }
  url = $https + url;
  let shouldCheck = true;
  ['/user/login', '/user/reg'].forEach(apiName => {
    if (url.includes(apiName)) shouldCheck = false;
  })
  console.log(url, shouldCheck);
  if (shouldCheck) {
    // 请求jsSdk 和指纹
    await checkPageCode();
  }
  // get请求
  if (method === 'get' || method === 'delete') {
    return axios({
      method: method,
      url: url,
      params: options,
      transformRequest: [res => {
        return res
      }],
    })
  } else if (method === 'post' || method === 'put') {
    // post put
    return axios({
      method: method,
      url: url,
      data: qs.stringify(options),
      transformRequest: [res => {
        return res
      }],
    })
  }
}

let isGetPageCode = false;

async function checkPageCode() {
  if (Storage.get('pageCode') && Storage.get('pddPati')) {
    return true;
  } else {
    if (isGetPageCode) {
      setTimeout(() => {
        checkPageCode()
      }, 300);
    } else {
      await getPageCode();
      isGetPageCode = false;
      return true;
    }
  }
}

async function getPageCode() {
  isGetPageCode = true;
  const res = await axios({
    url: `${BaseUrl}/PDDGoodsApi/getJsSdkCode`,
    method: 'get',
  });
  if (res.data.data.response) {
    const pageCode = res.data.data.response.pageCode;
    Storage.set('pageCode', pageCode, 60 * 60 * 4);
    PDD_OPEN_init({
      code: pageCode
      // 对于获取 code 接口或未登录态，可不传 code：PDD_OPEN_init({}, function () { ... })
    }, async () => {
      // 初始化已完成
      const pddPati = await window.PDD_OPEN_getPati().catch(error => console.log(error))
      Storage.set('pddPati', pddPati, 60 * 60 * 4);
    })
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/assets/js/Axios.js